import React from 'react';
import dynamic from 'next/dynamic';
import { Row } from 'reactstrap';
import {
  getLiveClassesDateFilter,
  setLiveClassesDateFilter,
} from 'store/global';
import { useDispatch, useSelector } from 'react-redux';
import CustomFlatpickr from 'components/Form/Picker/CustomFlatpickr';
import { MdOutlineDateRange } from 'react-icons/md';

const SparkLine = dynamic(() => import('./classesSparkLineChart'), {
  ssr: false,
});
const ColumnChart = dynamic(() => import('./columnChart'), { ssr: false });
const DonutChart = dynamic(() => import('./donutChart'), { ssr: false });
const TotalCounts = dynamic(() => import('./TotalCounts'), { ssr: false });
const LiveClasses = dynamic(() => import('../../LiveClasses/liveClasses'), {
  ssr: false,
});
const LineChart = dynamic(() => import('./LineChart'), { ssr: false });
const TopMostInstructor = dynamic(() => import('./TopMostInstructor'), {
  ssr: false,
});
//New Index Changes
const NewDashboardAdmin = () => {
  const dispatch = useDispatch();
  const liveClaasesDate = useSelector(getLiveClassesDateFilter);
  const getLiveClassesDate = (date) => {
    dispatch(setLiveClassesDateFilter(date));
  };
  const closeTime = (value) => {
    if (value?.length == 1) {
      dispatch(
        setLiveClassesDateFilter([
          new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(
            0,
            0,
            0,
          ),
          new Date().setHours(0, 0, 0),
        ]),
      );
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-50">
        <h4 className="card-header-title-label mb-0">Dashboard</h4>
        <section className="date-range-card-dashboard-new d-flex mb-0">
          <span style={{ margin: '0px -5px 6px 10px', paddingTop: '4px' }}>
            <MdOutlineDateRange color="#8E96AA" size={25} />
          </span>
          <span style={{ marginTop: '3px' }}>
            <CustomFlatpickr
              time={liveClaasesDate}
              setTime={getLiveClassesDate}
              closeTime={closeTime}
            />
          </span>
        </section>
      </div>
      <div className="w-100">
        <SparkLine />
      </div>
      <div className="d-flex w-100 flex-wrap">
        <div
          className={`col-md-8 px-0 d-flex flex-lg-row flex-column flex-wrap AdminCard_Charts`}
        >
          <div className="col-md-6 pl-0">
            <ColumnChart />
          </div>

          <div className="col-md-6 pl-0">
            <DonutChart />
          </div>

          <div className="col-md-6 pl-0">
            <LineChart />
          </div>

          <div className="col-md-6 pl-0">
            <LiveClasses />
          </div>
        </div>
        <div className="col-md-4 px-0">
          <div className="topmost_instructor_card">
            <TotalCounts />
          </div>
          <div>
            <TopMostInstructor />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewDashboardAdmin;
